import { render } from "./OpenOrders.vue?vue&type=template&id=7c6d42fa"
import script from "./OpenOrders.vue?vue&type=script&lang=js"
export * from "./OpenOrders.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/OpenOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c6d42fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c6d42fa', __exports__)) {
    api.reload('7c6d42fa', __exports__)
  }
  
  module.hot.accept("./OpenOrders.vue?vue&type=template&id=7c6d42fa", () => {
    api.rerender('7c6d42fa', render)
  })

}


export default __exports__